import { useRef, useState } from "react";
import { toast } from "sonner";
import { studio, apiError } from "@/lib/studioApi";

// Dictée : MediaRecorder → /studio/transcribe (Whisper) → onText(texte)
export const useDictation = (onText) => {
  const [recording, setRecording] = useState(false);
  const [transcribing, setTranscribing] = useState(false);
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mimeType = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/mp4";
      const recorder = new MediaRecorder(stream, { mimeType });
      chunksRef.current = [];
      recorder.ondataavailable = (e) => e.data.size && chunksRef.current.push(e.data);
      recorder.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunksRef.current, { type: mimeType });
        setRecording(false);
        if (blob.size < 1200) return toast.error("Enregistrement trop court.");
        setTranscribing(true);
        const fd = new FormData();
        fd.append("file", new File([blob], `dictee.${mimeType.includes("webm") ? "webm" : "mp4"}`, { type: mimeType }));
        try {
          const { data } = await studio.post("/transcribe", fd, { timeout: 180000 });
          onText(data.text);
        } catch (e) {
          toast.error(apiError(e, "Transcription impossible."));
        } finally {
          setTranscribing(false);
        }
      };
      mediaRef.current = recorder;
      recorder.start();
      setRecording(true);
    } catch {
      toast.error("Micro inaccessible. Autorisez l'accès au micro.");
    }
  };

  const toggle = () => (recording ? mediaRef.current?.stop() : start());

  return { recording, transcribing, toggle };
};
